import NavLinkGroup from '../../app/components/main-menu/components/nav-link-group/NavLinkGroup';
import NavLink from '../../app/components/main-menu/components/NavLink';
import UrlsService from '../../../common/router/services/urlsService.mdl';
import useSessionManager from '../../session/hooks/useSessionManager';
import {observer} from 'mobx-react';

export default observer(function ChartsLinks(): React.JSX.Element {
    const session = useSessionManager();

    return (
        <NavLinkGroup to={UrlsService.charts()} label="Charts" iconName="icon-dashboard">
            <NavLink to={UrlsService.charts()}>Charts List</NavLink>
            {session.isUserAllowed('create:chart') && <NavLink to={UrlsService.createChart()}>Create Chart</NavLink>}
        </NavLinkGroup>
    );
});
